<template>
  <!-- 懒加载树形组件 -->
  <el-select
    style="width: 100%;"
    ref="selectRef"
    v-model="selectedName"
    :placeholder="placeholder"
    :clearable="needDelIcon"
    @clear="selectClear"
  >
    <el-option :value="selectedName" :label="selectedName">
      <el-tree
        ref="tree"
        node-key="id"
        :data="treeData"
        :props="treeProps"
        :expand-on-click-node="false"
        :highlight-current="true"
        lazy
        :load="treeLazyLoad"
        @node-click="treeNodeClick"
      >
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'LazyTree',
  props: {
    // 节点属性
    treeProps: {
      type: Object,
      default: {
        label: 'title',
        value: 'id',
      },
    },
    // 选中的id
    selectedId: {
      type: String,
      default: '',
    },
    // 选中的文本
    selectedName: {
      type: String,
      default: '',
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
    // 叶子节点是否允许选中
    canLeafSelected: {
      type: Boolean,
      default: true,
    },
    // 是否默认选中第一个值
    needDefaultItem: {
      type: Boolean,
      default: false,
    },
    // 是否可清空图标
    needDelIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      treeData: [],
    };
  },
  methods: {
    /* 懒加载树 */
    treeLazyLoad(node, resolve) {
      let cb = resolve;
      if (this.needDefaultItem) {
        cb = (data) => {
          resolve(data);
          if (node.level == 0) {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(data[0].id);
              this.treeNodeClick(data[0]);
              this.$emit('setDefaultFinished');
            });
          }
        };
      }
      this.$emit('load', node, cb);
    },
    /* 清空输入框 */
    selectClear() {
      this.selectedName = '';
      this.selectedId = '';
      this.$emit('update:selectedId', this.selectedId);
      this.$emit('update:selectedName', this.selectedName);
    },
    /* 选中节点 */
    treeNodeClick(nodeData) {
      if (!this.canLeafSelected && (nodeData.nodeType == 1 || nodeData.isLeaf)) {
        return;
      } else {
        this.selectedName = nodeData[this.treeProps.label];
        this.selectedId = nodeData[this.treeProps.value];
        this.$emit('update:selectedId', this.selectedId);
        this.$emit('update:selectedName', this.selectedName);
        this.$refs.selectRef.blur();
      }
    },
  },
};
</script>
